export const manifest = {
  screens: {
    scr_apm0da: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_wdzfq2: { name: "Download the App", route: "/get-the-app", position: {"x":1560,"y":220} },
    scr_qos01c: { name: "Practitioners", route: "/practitioners", position: {"x":160,"y":2200} },
    scr_nczked: { name: "Investors", route: "/investors", position: {"x":1560,"y":2200} },
    scr_krpfwh: { name: "Privacy Policy", route: "/privacy-policy", position: {"x":2960,"y":220} },
    scr_ajdray: { name: "Terms of Service", route: "/terms-of-service", position: {"x":4360,"y":220} },
    scr_e4ye7g: { name: "Terms of Sale", route: "/terms-of-sale", position: {"x":5760,"y":220} },
    scr_nhy6dk: { name: "Practitioner – Create account", route: "/practitioners/join", position: {"x":160,"y":4180}, width: 1200, height: 1939 },
    scr_zufh80: { name: "Practitioner – Choose membership", route: "/practitioners/membership", position: {"x":1560,"y":4180}, width: 1300, height: 1939 },
    scr_uro0nv: { name: "Practitioner – After checkout (Download the App)", route: "/get-the-app", state: {"postCheckout":true}, position: {"x":7160,"y":4180} },
    scr_p4ovf0: { name: "Practitioner – Founding Member confirmed", route: "/practitioners/welcome", state: {"confirmationPreview":"confirmed"}, position: {"x":2960,"y":4180}, width: 1200, height: 1978 },
    scr_ycyrxp: { name: "Practitioner – Confirming membership", route: "/practitioners/welcome", state: {"confirmationPreview":"verifying"}, position: {"x":4360,"y":4180} },
    scr_pp27w4: { name: "Practitioner – Confirmation pending", route: "/practitioners/welcome", state: {"confirmationPreview":"processing"}, position: {"x":5760,"y":4180} },
  },
  sections: {
    sec_8aex0n: { name: "Main Navigation", x: 0, y: 0, width: 7120, height: 1180 },
    sec_nngm4a: { name: "User Audiences", x: 0, y: 1980, width: 2920, height: 1180 },
    sec_ncuvgt: { name: "Practitioner Registration", x: 0, y: 3960, width: 8520, height: 2708 },
  },
  layers: [
    { kind: "section", id: "sec_8aex0n", children: [
      { kind: "screen", id: "scr_apm0da" },
      { kind: "screen", id: "scr_wdzfq2" },
      { kind: "screen", id: "scr_krpfwh" },
      { kind: "screen", id: "scr_ajdray" },
      { kind: "screen", id: "scr_e4ye7g" },
    ] },
    { kind: "section", id: "sec_nngm4a", children: [
      { kind: "screen", id: "scr_qos01c" },
      { kind: "screen", id: "scr_nczked" },
    ] },
    { kind: "section", id: "sec_ncuvgt", children: [
      { kind: "screen", id: "scr_nhy6dk" },
      { kind: "screen", id: "scr_zufh80" },
      { kind: "screen", id: "scr_p4ovf0" },
      { kind: "screen", id: "scr_ycyrxp" },
      { kind: "screen", id: "scr_pp27w4" },
      { kind: "screen", id: "scr_uro0nv" },
    ] },
  ],
}
